import * as THREE from 'three';



const requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame ||
                            window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;

const cancelAnimationFrame = window.cancelAnimationFrame || window.mozCancelAnimationFrame;


class VideoLoader {

  constructor( src, el  ){
    this.src = src;
    this.$el = el;
    this.targetWidth  = this.$el.clientWidth;
    this.targetHeight = this.$el.clientHeight;
    this.videoSizeUpdated = false;
    this.loadedCallback   = null;
    this.loadedResolve = null;
    this.loadedReject  = null;
    this.drawRequest   = null;
  }

  updateSize(){
    this.targetWidth  = this.$el.clientWidth;
    this.targetHeight = this.$el.clientHeight;
  }

  updateStyle(){
    const s = {
      "position": "absolute",
      "top":  "0px", // - this.targetHeight + "px",
      "left": "0px", //- this.targetWidth + "px",
      "z-index": "-1",
      "opacity":0
          };

    const styleStr =  Object.keys( s ).map(  k  => ( k + ":" + s[k] ) ).join(";");
    this.video.setAttribute("style", styleStr );
    //this.videocanvas.setAttribute("style", styleStr )


  }


  loadVideo( loadedCallback ){
    this.loadedResolve = null;
    this.loadedReject  = null;

    return new Promise( function( resolve, reject ) {

      this.loadedResolve = resolve;
      this.loadedReject  = reject;

      const video = document.createElement('video');
      video.setAttribute("autoplay", true );
      video.setAttribute("loop", true );
      video.autoplay = true;
      video.muted = true;
      this.video = video;
      this.loadedCallback = loadedCallback;


      //make your video canvas
      const videocanvas = document.createElement('canvas');
      const videocanvasctx = videocanvas.getContext('2d');

      //set its size
      const width =  640;
      const height = 480;
      videocanvas.width  = this.targetWidth;
      videocanvas.height = this.targetHeight;

      //draw a black rectangle so that your spheres don't start out transparent
      videocanvasctx.fillStyle = "#000000";
      videocanvasctx.fillRect(0,0,this.targetWidth,this.targetHeight);
      this.videocanvasctx = videocanvasctx;
      this.videocanvas = videocanvas;
      this.updateStyle();
      document.body.appendChild( this.video );
      //this.$el.appendChild( this.videocanvas );
      this.texture = new THREE.Texture(this.videocanvas);
      this.texture.minFilter = THREE.LinearFilter;
      this.texture.magFilter = THREE.LinearFilter;
      this.texture.format    = THREE.RGBFormat;
      this.bindEvent();

    }.bind(this));
  }

  bindEvent(){
    this.video.onloadedmetadata = function(){
      console.log('The duration and dimensions ' + this.video.videoWidth + " , " + this.video.videoHeight );
    }.bind(this);
  }

  positionVideo() {
    if( this.video.videoWidth ) {
      const vw = this.video.videoWidth;
      const vh = this.video.videoHeight;
      const ratio = Math.max( ( this.targetWidth / vw ), ( this.targetHeight / vh ) );
      this.sourceDrawOffsetX = 0;
      this.sourceDrawOffsetY = 0;
      this.videoRatio  = ratio;
      this.sourceCropWidth   = this.targetWidth / ratio; 
      this.sourceCropHeight  = this.targetHeight / ratio; 

      if(  ( this.video.videoWidth * ratio )  >  this.targetWidth ) {
        this.sourceDrawOffsetX = (this.video.videoWidth  -  this.sourceCropWidth  ) / 2;
      }  
      if(  ( this.video.videoHeight * ratio )  >  this.targetHeight ) {
        this.sourceDrawOffsetY = (this.video.videoHeight  -  this.sourceCropHeight ) / 2;
      }  
    } 
  }

  start(){
    this.video.src = this.src;
    this.video.load();
    //this.video.play();
    this.updateCanvas();
  }

  destroy(){
    if( this.drawRequest ) {
      cancelAnimationFrame( this.drawRequest );
      this.drawRequest = null;
    }
    this.video.remove();
    this.videocanvasctx = null;
    this.videocanvas     = null;
    this.texture = null;
  }

  stop(){
    this.video.stop();
  }

  getTexture(){
    return this.texture;
  }

  updateCanvas(){
    if( this.video.readyState === this.video.HAVE_ENOUGH_DATA ){
      if( !this.videoSizeUpdated ) {
        this.positionVideo();
        this.videoSizeUpdated = true;
      }
      //draw video to canvas starting from upper left corner
      this.videocanvasctx.drawImage( this.video, 0, 0, this.targetWidth, this.targetHeight );
        // this.sourceDrawOffsetX, this.sourceDrawOffsetY,
        // this.sourceCropWidth, this.sourceCropHeight,
        // 0, 0, 
        // this.targetWidth, this.targetHeight );
      this.texture.needsUpdate = true;
      //tell texture object it needs to be updated
      if(( this.loadedCallback || null ) != null ){
        this.loadedCallback();
        this.loadedCallback = null;
      }

      if( this.loadedResolve != null ){
        this.loadedResolve();
        this.loadedResolve = null;
        this.loadedReject  = null;
      }
    }
    this.drawRequest = requestAnimationFrame( this.updateCanvas.bind(this) ); 
  }
}


VideoLoader.load = function( videoSrc, el ) {
  const vt = new VideoLoader( videoSrc, el  );
  return vt;
} 

export default VideoLoader;